import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { setMsalInstance } from '../services/api';
import { useChatStore } from '../stores/chatStore';
import Header from './Header';

export default function Layout() {
  const { instance } = useMsal();
  const { loadProfile, loadSessions } = useChatStore();

  useEffect(() => {
    // Set MSAL instance for API calls
    setMsalInstance(instance as PublicClientApplication);
  }, [instance]);

  useEffect(() => {
    // Load user profile and sessions on mount
    loadProfile();
    loadSessions();
  }, [loadProfile, loadSessions]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
      <footer className="py-2 text-center text-xs text-gray-400">
        v{import.meta.env.VITE_APP_VERSION || '0.1.0'}
      </footer>
    </div>
  );
}
